module.exports = __webpack_public_path__ + "img/a2.9a3b8f7a.jpg";